(function($) {

  var $body = $('body');

  $(window).on('load', function() {
    $body.removeClass('loading');
  });

}(jQuery));



// WEBPACK FOOTER //
// ./assets/js/load.js